
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zai",
      function () {
        return require("private-next-pages/zai/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zai"])
      });
    }
  